const tableData = [
  { 
    id:  1,  
    account: 'Joko Widodo',
    avatar: 'avatar-10.jpg',
    followers: 1600000, 
    following: 58,
    post: 666,
    status: 1,
    updated:'Friday, 21-05-2021 15:06:53'
  },
  { 
    id:  2,  
    account: 'Sandiaga Uno',
    avatar: 'avatar-10.jpg',
    followers: 1600000, 
    following: 58,
    post: 666,
    status: 1,
    updated:'Friday, 21-05-2021 15:06:53'
  },
  { 
    id:  3,  
    account: 'Atta Halilintar',
    avatar: 'avatar-14.jpg',
    followers: 110800, 
    following: 56,
    post: 666,
    status: 1,
    updated:'Friday, 29-06-2021 15:06:53'
  },
];

const timelineTweet = [
{ 
id:  1,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  2,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  3,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  4,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  5,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  6,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  7,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  8,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  9,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  10,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  11,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
},
{ 
id:  12,  
date: 'Friday, 06 Aug 2021 14:53',
posts: 'RS Modular Pertamina di Tanjung Duren, Jakarta, mulai beroperasi hari ini. Dengan kapasitas 305 tempat tidur',
like: 549, 
retweets: 1000,
}
];

const seriesHeatMap = [
  {
    name: "Sunday",
    data: [{
      x: '00:00',
      y: 22
    }, {
      x: '01:00',
      y: 29
    }, {
      x: '03:00',
      y: 13
    }, {
      x: '04:00',
      y: 32
    },
    {
      x: '05:00',
      y: 29
    }, {
      x: '06:00',
      y: 13
    }, {
      x: '07:00',
      y: 32
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 13
    }, {
      x: '10:00',
      y: 32
    },
    {
      x: '11:00',
      y: 29
    }, {
      x: '12:00',
      y: 13
    }, {
      x: '13:00',
      y: 32
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 13
    }, {
      x: '16:00',
      y: 32
    },
    {
      x: '17:00',
      y: 29
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 32
    },
    {
      x: '20:00',
      y: 29
    }, {
      x: '21:00',
      y: 13
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 29
    }, {
      x: '24:00',
      y: 13
    }]
  },
  {
    name: "Monday",
    data: [{
      x: '00:00',
      y: 0
    }, {
      x: '01:00',
      y: 0
    }, {
      x: '03:00',
      y: 0
    }, {
      x: '04:00',
      y: 0
    },
    {
      x: '05:00',
      y: 29
    }, {
      x: '06:00',
      y: 0
    }, {
      x: '07:00',
      y: 32
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 13
    }, {
      x: '10:00',
      y: 2
    },
    {
      x: '11:00',
      y: 29
    }, {
      x: '12:00',
      y: 4
    }, {
      x: '13:00',
      y: 32
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 13
    }, {
      x: '16:00',
      y: 6
    },
    {
      x: '17:00',
      y: 29
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 32
    },
    {
      x: '20:00',
      y: 7
    }, {
      x: '21:00',
      y: 13
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 11
    }, {
      x: '24:00',
      y: 13
    }]
  },
  {
    name: "Tuesday",
    data: [{
      x: '00:00',
      y: 22
    }, {
      x: '01:00',
      y: 29
    }, {
      x: '03:00',
      y: 13
    }, {
      x: '04:00',
      y: 32
    },
    {
      x: '05:00',
      y: 29
    }, {
      x: '06:00',
      y: 13
    }, {
      x: '07:00',
      y: 32
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 13
    }, {
      x: '10:00',
      y: 32
    },
    {
      x: '11:00',
      y: 29
    }, {
      x: '12:00',
      y: 13
    }, {
      x: '13:00',
      y: 32
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 13
    }, {
      x: '16:00',
      y: 32
    },
    {
      x: '17:00',
      y: 29
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 32
    },
    {
      x: '20:00',
      y: 29
    }, {
      x: '21:00',
      y: 13
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 29
    }, {
      x: '24:00',
      y: 13
    }]
  },
  {
    name: "Wedesday",
    data: [{
      x: '00:00',
      y: 0
    }, {
      x: '01:00',
      y: 1
    }, {
      x: '03:00',
      y: 13
    }, {
      x: '04:00',
      y: 4
    },
    {
      x: '05:00',
      y: 29
    }, {
      x: '06:00',
      y: 13
    }, {
      x: '07:00',
      y: 5
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 13
    }, {
      x: '10:00',
      y: 32
    },
    {
      x: '11:00',
      y: 3
    }, {
      x: '12:00',
      y: 13
    }, {
      x: '13:00',
      y: 32
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 2
    }, {
      x: '16:00',
      y: 32
    },
    {
      x: '17:00',
      y: 29
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 6
    },
    {
      x: '20:00',
      y: 29
    }, {
      x: '21:00',
      y: 9
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 29
    }, {
      x: '24:00',
      y: 4
    }]
  },
  {
    name: "Thuesday",
    data: [{
      x: '00:00',
      y: 22
    }, {
      x: '01:00',
      y: 29
    }, {
      x: '03:00',
      y: 13
    }, {
      x: '04:00',
      y: 32
    },
    {
      x: '05:00',
      y: 29
    }, {
      x: '06:00',
      y: 13
    }, {
      x: '07:00',
      y: 32
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 13
    }, {
      x: '10:00',
      y: 32
    },
    {
      x: '11:00',
      y: 29
    }, {
      x: '12:00',
      y: 13
    }, {
      x: '13:00',
      y: 32
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 13
    }, {
      x: '16:00',
      y: 32
    },
    {
      x: '17:00',
      y: 29
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 32
    },
    {
      x: '20:00',
      y: 29
    }, {
      x: '21:00',
      y: 13
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 29
    }, {
      x: '24:00',
      y: 13
    }]
  },
  {
    name: "Friday",
    data: [{
      x: '00:00',
      y: 2
    }, {
      x: '01:00',
      y: 4
    }, {
      x: '03:00',
      y: 13
    }, {
      x: '04:00',
      y: 32
    },
    {
      x: '05:00',
      y: 9
    }, {
      x: '06:00',
      y: 13
    }, {
      x: '07:00',
      y: 32
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 4
    }, {
      x: '10:00',
      y: 32
    },
    {
      x: '11:00',
      y: 29
    }, {
      x: '12:00',
      y: 13
    }, {
      x: '13:00',
      y: 9
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 13
    }, {
      x: '16:00',
      y: 32
    },
    {
      x: '17:00',
      y: 10
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 32
    },
    {
      x: '20:00',
      y: 29
    }, {
      x: '21:00',
      y: 11
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 29
    }, {
      x: '24:00',
      y: 13
    }]
  },
  {
    name: "Saturday",
    data: [{
      x: '00:00',
      y: 22
    }, {
      x: '01:00',
      y: 29
    }, {
      x: '03:00',
      y: 13
    }, {
      x: '04:00',
      y: 32
    },
    {
      x: '05:00',
      y: 29
    }, {
      x: '06:00',
      y: 13
    }, {
      x: '07:00',
      y: 32
    },
    {
      x: '08:00',
      y: 29
    }, {
      x: '09:00',
      y: 13
    }, {
      x: '10:00',
      y: 32
    },
    {
      x: '11:00',
      y: 29
    }, {
      x: '12:00',
      y: 13
    }, {
      x: '13:00',
      y: 32
    },
    {
      x: '14:00',
      y: 29
    }, {
      x: '15:00',
      y: 13
    }, {
      x: '16:00',
      y: 32
    },
    {
      x: '17:00',
      y: 29
    }, {
      x: '18:00',
      y: 13
    }, {
      x: '19:00',
      y: 32
    },
    {
      x: '20:00',
      y: 29
    }, {
      x: '21:00',
      y: 13
    }, {
      x: '22:00',
      y: 32
    },
    {
      x: '23:00',
      y: 29
    }, {
      x: '24:00',
      y: 13
    }]
  },
  
  
  
  ];

const topMention = [
  {  
    mention: 'sandiagauno',
    total: '1',
    percentage: '50%',
    link: 'https://twitter.com/sandiuno',
  },
  {  
    mention: 'prabowo',
    total: '1',
    percentage: '50%',
    link: 'https://twitter.com/prabowo',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  {  
    mention: '-',
    total: '-',
    percentage: '0%',
    link: '#',
  },
  
  ];

  const topFollowers = [
    {  
      account: 'Rian Agustian',
      followers: '1',
      following: '2',
      post: '0',
      avatar:'@/assets/images/users/avatar-100.jpg'
    },
    {  
      account: 'Rian Agustian',
      followers: '1',
      following: '2',
      post: '0',
      avatar:'@/assets/images/users/avatar-100.jpg'
    },
    {  
      account: 'Rian Agustian',
      followers: '1',
      following: '2',
      post: '0',
      avatar:'@/assets/images/users/avatar-100.jpg'
    },
    {  
      account: 'Rian Agustian',
      followers: '1',
      following: '2',
      post: '0',
      avatar:'@/assets/images/users/avatar-100.jpg'
    },
    {  
      account: 'Rian Agustian',
      followers: '1',
      following: '2',
      post: '0',
      avatar:'@/assets/images/users/avatar-100.jpg'
    },
    
    ];

    const topFollowing = [
      {  
        account: 'Ganjar Pranowo',
        followers: '100000',
        following: '200',
        post: '1001010',
        avatar:'@/assets/images/users/avatar-14.jpg'
      },
      {  
        account: 'Ganjar Pranowo',
        followers: '100000',
        following: '200',
        post: '1001010',
        avatar:'@/assets/images/users/avatar-14.jpg'
      },
      {  
        account: 'Ganjar Pranowo',
        followers: '100000',
        following: '200',
        post: '1001010',
        avatar:'@/assets/images/users/avatar-14.jpg'
      },
      {  
        account: 'Ganjar Pranowo',
        followers: '100000',
        following: '200',
        post: '1001010',
        avatar:'@/assets/images/users/avatar-14.jpg'
      },
      {  
        account: 'Ganjar Pranowo',
        followers: '100000',
        following: '200',
        post: '1001010',
        avatar:'@/assets/images/users/avatar-14.jpg'
      },
      
    ];
      
    const topWordCloud = [
      {  
        wordCloud: 'Indonesia',
        total: '41',
        percentage: '20%',
      },
      {  
        wordCloud: 'Covid',
        total: '38',
        percentage: '19%',
      },
      {  
        wordCloud: 'Vaksinisasi',
        total: '28',
        percentage: '12%',
      },
      {  
        wordCloud: 'Dosis',
        total: '23',
        percentage: '11%',
      },
      {  
        wordCloud: 'Siang',
        total: '14',
        percentage: '8%',
      },
      {  
        wordCloud: 'Jakarta',
        total: '13',
        percentage: '7%',
      },
      {  
        wordCloud: 'Pademi',
        total: '13',
        percentage: '6%',
      },

      {  
        wordCloud: 'Pemerintah',
        total: '11',
        percentage: '5%',
      },
      {  
        wordCloud: 'Tokyo',
        total: '10',
        percentage: '5%',
      },
    ];

    const topHastag = [
      {  
        hastag: 'ALM',
        total: '1',
        percentage: '100%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
      {  
        hastag: '-',
        total: '-',
        percentage: '0%',
      },
     
    ];
    

export { timelineTweet, tableData, seriesHeatMap, topMention, topFollowing, topFollowers, topWordCloud, topHastag };